import React, { createContext, useContext } from 'react'

import useStore from './hooks/useStore'

type ContextState = ReturnType<typeof useStore>

const CurrentStoreContext = createContext<ContextState | undefined>(undefined)

function StoreProvider({ children }: React.PropsWithChildren) {
  const state = useStore()

  return <CurrentStoreContext.Provider value={state}>{children}</CurrentStoreContext.Provider>
}

export const useStoreContext = () => {
  const context = useContext(CurrentStoreContext)
  if (!context) {
    throw new Error('useStoreContext must be used within a CurrentStoreProvider')
  }
  return context
}

export default StoreProvider
